import { useQuery, useQueryClient } from '@tanstack/react-query';
import { meResponseSchema } from '@ailab/contracts';
import { ApiRequestError, apiRequest } from './http';

export const ME_QUERY_KEY = ['me'] as const;

/** Cuenta actual o `null` sin sesión. Solo adapta la interfaz: el servidor decide. */
export function useMe() {
  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: async () => {
      try {
        return await apiRequest('/me', meResponseSchema);
      } catch (error) {
        if (error instanceof ApiRequestError && error.status === 401) return null;
        throw error;
      }
    },
    retry: false,
  });
}

export function useRefreshMe() {
  const client = useQueryClient();
  return () => client.invalidateQueries({ queryKey: ME_QUERY_KEY });
}
